import React, { useState, useEffect, useCallback } from 'react';
import '../src/i18n';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { BrandingProvider } from './context/BrandingContext';
import { useAuth } from './context/AuthContext';
import { useBranding } from './context/BrandingContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import CategoryPage from './pages/CategoryPage';
import LoginPage from './pages/LoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import SalesStatisticsPage from './pages/admin/SalesStatisticsPage';
import ProductManagementPage from './pages/admin/ProductManagementPage';
import CategoryManagementPage from './pages/admin/CategoryManagementPage';
import AccessHistoryPage from './pages/admin/AccessHistoryPage';
import EditHistoryPage from './pages/admin/EditHistoryPage';
import SystemSettingsPage from './pages/admin/SystemSettingsPage';
import DiagnosticPage from './pages/DiagnosticPage';
import Footer from './components/Footer';
import PopupManager from './components/PopupManager';
import TokenMigrationBanner from './components/TokenMigrationBanner';
import SessionWarningModal from './components/SessionWarningModal';
import { WhatsAppWidget } from 'react-whatsapp-widget';
import 'react-whatsapp-widget/dist/index.css';

// Sistema de traducción mediante cookies de Google Translate
window.changeLanguage = function(lang) {
  console.log('🌐 Cambiando idioma a:', lang);
  
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  // Función para eliminar cookies de Google Translate
  const clearGoogleTranslateCookies = () => {
    const cookies = ['googtrans', 'googtrans-domain'];
    const hostname = window.location.hostname;
    
    cookies.forEach(cookieName => {
      // Limpieza básica
      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + hostname;
      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.' + hostname;
      
      // Para subdominios como newtarifario.chirak.cl
      if (!isLocalhost) {
        // Extraer dominio raíz (chirak.cl de newtarifario.chirak.cl)
        const parts = hostname.split('.');
        if (parts.length >= 2) {
          const rootDomain = parts.slice(-2).join('.'); // chirak.cl
          console.log('🧹 Limpiando cookies en dominio raíz:', rootDomain);
          
          // Limpiar en el dominio raíz
          document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + rootDomain;
          document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.' + rootDomain;
          document.cookie = cookieName + '=; max-age=0; path=/; domain=' + rootDomain;
          document.cookie = cookieName + '=; max-age=0; path=/; domain=.' + rootDomain;
        }
        
        // Intentar sin dominio también
        document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; max-age=0; path=/';
      }
    });
  };
  
  if (lang === 'es') {
    // Volver a español
    console.log('🔄 Volviendo a español...');
    clearGoogleTranslateCookies();
    
    setTimeout(() => {
      clearGoogleTranslateCookies();
      
      // Mantener la URL completa incluyendo hash y parámetros
      const fullUrl = window.location.href;
      const separator = fullUrl.includes('?') ? '&' : '?';
      
      if (!isLocalhost) {
        window.location.replace(fullUrl + separator + 'nocache=' + Date.now() + '&clear=1');
      } else {
        window.location.href = fullUrl + separator + 'nocache=' + Date.now();
      }
    }, 150);
  } else {
    // Cambiar a otro idioma
    console.log('✅ Aplicando traducción a:', lang);
    clearGoogleTranslateCookies();
    
    const googleTransCookie = '/es/' + lang;
    const hostname = window.location.hostname;
    
    setTimeout(() => {
      // Establecer cookie SOLO en el subdominio actual
      document.cookie = 'googtrans=' + googleTransCookie + '; path=/; max-age=3600';
      
      if (!isLocalhost) {
        // También en el subdominio específico
        document.cookie = 'googtrans=' + googleTransCookie + '; path=/; domain=' + hostname + '; max-age=3600';
        
        console.log('🍪 Cookie establecida para:', hostname, '=', googleTransCookie);
      }
      
      setTimeout(() => {
        // Mantener la URL completa incluyendo hash y parámetros
        const fullUrl = window.location.href;
        const separator = fullUrl.includes('?') ? '&' : '?';
        
        if (!isLocalhost) {
          window.location.replace(fullUrl + separator + 'lang=' + lang + '&t=' + Date.now());
        } else {
          window.location.href = fullUrl + separator + 'lang=' + lang + '&t=' + Date.now();
        }
      }, 150);
    }, 150);
  }
};

// Componente interno para acceder a useLocation
const AppContent = ({ selectedCategory, handleCategorySelect, handleBackToDashboard, resetCategory }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { getCurrentBranding } = useBranding();
  const isLoginPage = location.pathname === '/login' || !user;
  const currentBranding = getCurrentBranding();
  
  // Resetear categoría cuando cambia el usuario (login/logout)
  useEffect(() => {
    if (resetCategory) {
      resetCategory();
    }
  }, [user?.id, resetCategory]);

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/diagnostic" element={<DiagnosticPage />} />
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute>
                      {selectedCategory ? (
                        <CategoryPage 
                          category={selectedCategory} 
                          onBack={handleBackToDashboard}
                          onCategoryChange={handleCategorySelect}
                        />
                      ) : (
                        <DashboardPage onCategorySelect={handleCategorySelect} />
                      )}
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute>
                      <AdminDashboardPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/users" 
                  element={
                    <ProtectedRoute>
                      <UserManagementPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/sales" 
                  element={
                    <ProtectedRoute>
                      <SalesStatisticsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/products" 
                  element={
                    <ProtectedRoute>
                      <ProductManagementPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/categories" 
                  element={
                    <ProtectedRoute>
                      <CategoryManagementPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/access-history" 
                  element={
                    <ProtectedRoute>
                      <AccessHistoryPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/edit-history" 
                  element={
                    <ProtectedRoute>
                      <EditHistoryPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/settings" 
                  element={
                    <ProtectedRoute>
                      <SystemSettingsPage />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </main>
            <Footer />
            <PopupManager />
            <TokenMigrationBanner />
            {/* Widget de WhatsApp flotante - oculto en login */}
            {!isLoginPage && currentBranding?.whatsapp_number && (
              <div style={{ position: 'fixed', bottom: 32, right: 32, zIndex: 1000 }}>
                <WhatsAppWidget
                  phoneNumber={currentBranding.whatsapp_number}
                  companyName={currentBranding.name || "Turismo Chirak"}
                  message="¡Hola! ¿En qué podemos ayudarte?"
                  sendButtonText="Enviar"
                />
              </div>
            )}
          </div>
  );
};

const App = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleBackToDashboard = () => {
    setSelectedCategory(null);
  };
  
  const resetCategory = useCallback(() => {
    setSelectedCategory(null);
  }, []);

  return (
    <AuthProvider>
      <SettingsProvider>
        <BrandingProvider>
          <Router>
            <SessionWarningModal />
            <AppContent 
              selectedCategory={selectedCategory}
              handleCategorySelect={handleCategorySelect}
              handleBackToDashboard={handleBackToDashboard}
              resetCategory={resetCategory}
            />
          </Router>
        </BrandingProvider>
      </SettingsProvider>
    </AuthProvider>
  );
};

export default App;